import React, { useEffect, useState } from 'react'
import { Row, Col, Spin } from 'antd';
import { getCartItems, removeCartItem } from '../helper/cart';
import { Link } from 'react-router-dom';



function Cart() {
  const [loading, setLoading] = useState(true)
  const [cartItems, setCartItems] = useState([])
  const fetchCartItems = async () => {
    setLoading(true)
    const items = await getCartItems()
    setCartItems(items)
    setLoading(false)
  }
  useEffect(() => {
    fetchCartItems()
  }, [])
  useEffect(() => {
    console.log('cartItems', cartItems)
  }, [cartItems])
  return (
    <div>
      <section className='cart-card'>
        <div className="container">
          {loading ? <div className="page-loader"><Spin size="large" /></div> : <>
            {cartItems.length > 0 ? <>
              {cartItems.map((item, ind) => {
                return (<Row
                  gutter={[16, 16]}
                  justify="center"
                  align="start"
                  className="cart-row"
                  key={ind}
                >
                  <Col
                    xs={24}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="cart-image-col"
                  >
                    <div className="cart-image">
                      <img src={item.Images[0].FullUrl} alt={item.Description} />
                    </div>
                  </Col>

                  {/* Second Column: Cart Summary */}
                  <Col xs={24} sm={12} md={12} lg={12} xl={12} className="cart-summary-col" >
                    <div className="main-cart-custom">
                      <div className="cart-text">
                        <h2>{item.Description}</h2>
                        {/* <p>{item.Description}</p> */}
                        <p>
                          <span>{item.GroupDescription}</span>
                        </p>
                        <h6>Ring Size: ({item.ringSize}) | ({item.quantity}) x ${item.ShowcasePrice.Value.toFixed(2)} each</h6>
                      </div>
                      <div>
                        <div className="loop-cart">
                          <h5>{item.quantity} Item /</h5>
                          <h6>${(item.ShowcasePrice.Value * item.quantity).toFixed(2)}</h6>
                        </div>
                        <button onClick={() => {
                          removeCartItem(item.SKU)
                          fetchCartItems()
                        }} className="remove-cart">Remove</button>
                      </div>
                    </div>
                  </Col>
                </Row>)

              })}
              <Link className='checkout-btn' to='/checkout'>Proceed to Checkout</Link></>
              : <div className='empyt-cart'>
                <h2 className='theme-h2 text-center'>No Item in Cart</h2>
                <Link to='/'>Go to Website</Link>
              </div>}
          </>}
        </div>
      </section>
    </div>
  )
}

export default Cart
